/* unplugin-vue-components disabled */import script from "./CommonTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonTitle.vue?vue&type=script&setup=true&lang=js"

import "./CommonTitle.vue?vue&type=style&index=0&id=146e3302&lang=less&scoped=true"

import exportComponent from "C:\\Users\\小刘\\Desktop\\wanwei\\cydf-h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-146e3302"]])

export default __exports__